<template>
    <v-card :class="{['bg-inner']: true, alerta}" :elevation="$$_elevacao">
      <v-card-title>
        <titulo-questao :numero="numero" :nome="detalhe.foqnome" :obrigatorio="detalhe.foqobrigatorio === 'S'" />
      </v-card-title>
      <v-card-subtitle>
        {{detalhe.foqdescricao}}
      </v-card-subtitle>
      <v-card-text>

        <v-text-field
          v-if="detalhe.foqnome === 'CPF'"
          v-model="value"
          v-mask="'###.###.###-##'"
        ></v-text-field>

        <v-text-field :maxlength="limite" :counter="limite"
         v-else  v-model="value">
        </v-text-field>

      <template v-if="(detalhe && detalhe.subquestoes && detalhe.subquestoes.length > 0) && !complemento">
        <template v-for="(subitem, index) in detalhe.subquestoes">
          <div :key="subitem.id">
            <v-divider></v-divider>
            <component
            :is="componenteCard(subitem.foqtipo)"
            :key="subitem.id"
            :ref="`subquestao-${index + 1}`"
            :detalhe="subitem"
            :complemento="true"
            >
            </component>
          </div>
        </template>
      </template>

      </v-card-text>
    </v-card>
</template>

<script>
import { mask } from 'vue-the-mask';
import errorHandler from '../../utils/error-handler';
import { componenteCard, limiteTexto } from '../../utils/tipo-card';
import TituloQuestao from '../TituloQuestao.vue';

export default {
  name: 'card-text',

  components: {
    TituloQuestao,
  },

  directives: { mask },

  data() {
    return {
      value: this.detalhe.forcpfpadrao || this.detalhe.fornomepadrao || null,
      alerta: false,
    };
  },

  methods: {
    componenteCard,
    $_alerta() {
      this.alerta = true;
      errorHandler(`${this.$props.detalhe.foqnome} é obrigatória!`);
    },
  },

  props: {
    // Ordem da questão no formulário (ex.: "1-2"), calculada pelo Checklist.
    // Subquestões (complemento) não recebem.
    numero: {
      type: String,
      default: null,
    },
    detalhe: Object,
    complemento: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    $$_elevacao() {
      return (this.$props.complemento) ? 5 : 0;
    },
    // Limite vem do sufixo do foqtipo (card-text-4000). Nome/CPF não têm foqtipo: padrão.
    limite() {
      return limiteTexto(this.detalhe.foqtipo);
    },
  },
  mounted() {
    if (this.detalhe.forcpfpadrao || this.detalhe.fornomepadrao) {
      this.value = this.detalhe.forcpfpadrao || this.detalhe.fornomepadrao;
    }

    if (this.detalhe && this.detalhe.resposta) {
      const [res] = this.detalhe.resposta;
      this.value = res && res.forresposta;
    }
  },

  watch: {
    value(valor) {
      if (valor) {
        this.alerta = false;
      }
    },
  },
};
</script>

<style scoped>
  .bg-inner {
    width: 100%;
    background-color: #ffffff;
    border-radius: 15px;
    margin-top: 25px;
  }

  .obrigatorio {
    color: red;
    padding-left: 5px;
  }

  .alerta {
    border: 1px solid red;
    animation: vibracao 0.5s;
  }

  @keyframes vibracao {
    0% { transform: translateX(10px); }
    25% { transform: translateX(-10px); }
    50% { transform: translateX(10px); }
    75% { transform: translateX(-10px); }
    100% { transform: translateX(0px); }
  }
</style>
